<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <validador-data-table
          :items="validacoes"
          :loading="loading"
          @recharge="getAllValidacoes()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAllValidacoes())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ValidadorContabilService from '@/services/ValidadorContabilService';
  import dayjs from 'dayjs';
  import tourMixins from '@/mixins/tourMixins';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      ValidadorDataTable: () => import('@/components/validadorContabil/ValidadorDataTable')
    },
    mixins: [pusherMixins, tourMixins],

    data() {
      return {
        validacoes: [],
        loading: false,
        processamentosExpirados: false,
        arrTour: [
          {
            element: '#btn-nova-validacao',
            intro: 'Clicando neste botão você poderá criar novos testes de Validação Contábil.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#validacoes-historico-search',
            intro: 'Neste campo você poderá pesquisar por testes de Validação Contábil já existentes.',
            scrollTo: 'tooltip',
            position: 'bottom'
          },
          {
            element: '#action-download-validacao',
            intro: 'Clicando neste ícone você poderá fazer o download em .zip do resultado de seu teste de Validação Contábil.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-more-validacao',
            intro: 'Aqui você acessa outras opções para seu teste de Validação Contábil, como executá-lo novamente ou deletá-lo.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },

    mounted() {
      this.subscribe();
      this.getAllValidacoes();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('reload-pag-validador-contabil', () => {
          this.getAllValidacoes();
        });
      },
      getAllValidacoes() {
        this.loading = true;
        this.validacoes = [];

        ValidadorContabilService.getAllValidacoes(this.processamentosExpirados)
          .then((response) => {
            const lista = response.data.data;

            lista.forEach((element) => {
              this.validacoes.push({
                id: element.id,
                nome: element.nome,
                testes: element.testes ? JSON.parse(element.testes) : {},
                data_imobilizacao_inicial: element.data_imobilizacao_inicial
                  ? dayjs(element.data_imobilizacao_inicial).format('DD/MM/YYYY')
                  : '-',
                data_imobilizacao_final: element.data_imobilizacao_final
                  ? dayjs(element.data_imobilizacao_final).format('DD/MM/YYYY')
                  : '-',
                ais_database: element.ais_database ? dayjs(element.ais_database).format('MM/YYYY') : '-',
                status: element.status,
                data_execucao: element.data_processamento ? dayjs(element.data_processamento).format('DD/MM/YYYY HH:mm') : '-',
                usuario: element.usuario?.nome ?? '-',
                usuario_id: element.usuario?.id ?? null
              });
            });
          })
          .catch(() => {
            this.$toast.error('Erro ao recuperar validações.', '', { position: 'topRight' });
          })
          .finally(() => {
            this.loading = false;
            this.iniciarTourPagina();
          });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        let arrTourFormatted = this.validacoes.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>
